import React from "react";
import { Tag } from "antd";
import { useTranslation } from "react-i18next";

const Tagcomp = ({ text }) => {
  const { t } = useTranslation("dashboard");
  if (!text) return <Tag color="default">-</Tag>;

  if (
    text === "HIGH" ||
    text === "IN PROGRESS" ||
    text === "ISSUES" ||
    text === "REJECTED" ||
    text === "InActive" ||
    text === "Rejected" ||
    text === "Declined" ||
    text === "OVERDUE"
  ) {
    return <Tag color="red">{t(text)}</Tag>;
  }

  if (
    text === "MEDIUM" ||
    text === "REVISION" ||
    text === "Pending" ||
    text === "PENDING"
  ) {
    return <Tag color="orange">{t(text)}</Tag>;
  }

  if (
    text === "Partially Invoiced" ||
    text === "Sent"
  ) {
    return <Tag color="blue">{t(text)}</Tag>;
  }

  if (
    text === "LOW" ||
    text === "JUST ADDED" ||
    text === "COMPLETED" ||
    text === "Active" ||
    text === "JUST CREATED" ||
    text === "Available" ||
    text === "Approved" ||
    text === "Accepted" ||
    text === "PAID" ||
    text === "Invoiced" ||
    text === "Fully Invoiced"
  ) {
    return <Tag color="green">{t(text)}</Tag>;
  }

  return <Tag color="default">{t(text)}</Tag>;
};

export default Tagcomp;
